﻿import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {config} from './config';
import {Observable, throwError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class SettingsService {
    constructor(private http: HttpClient) {
        this.requestModel = {};
        this.settings = <ISettings>{};
    }

    public path: string = '/settings';

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }

    getSettings() {
        let headers: HttpHeaders = new HttpHeaders();
        return this.http.get(`${config.apiUrl}${this.path}/details.php`,{headers}).pipe(
            map((res) => {
                this.settings = <ISettings>res;
                return res;
            }),
            catchError(this.handleError));
    }

    requestModel: any;

    dataChange: EventEmitter<any> = new EventEmitter();

    public emitDataChangeEvent(data: ISettings) {
        this.dataChange.emit(data);
    }

    public getDataChangeEmitter() {
        return this.dataChange;
    }

    public setHotList(data: ISettings) {
        this.settings = data;
        this.emitDataChangeEvent(this.settings);
    }

    public getHotList(): ISettings {
        return this.settings;
    }

    public settings: ISettings = <ISettings>{};

    public getSkin() {
        return this.settings.skin;
    }

}

export interface ISettings{
    skin: string;
}




